import { FileResponse } from 'model/essential-types';

export abstract class VariousReportsApi {
  abstract getCountriesReport(): Promise<FileResponse>;
  abstract getAirlinesReport(): Promise<FileResponse>;
}
